import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  success: false,
  errorMessage: null,
  saving: false
};

const EventSongNoteSlice = createSlice({
  name: "EventSongNote",
  initialState,
  reducers: {
    eventSongNoteSaving(state) {
      state.saving = true;
      state.errorMessage = null;
    },
    eventSongNoteSuccess(state) {
      state.success = true;
      state.saving = false;
    },
    eventSongNoteError(state, action) {
      state.errorMessage = action.payload;
      state.saving = false;
    },
    eventSongNoteReset(state) {
      state.success = false;
      state.errorMessage = null;
      state.saving = false;
    }
  },
});

export const {
  eventSongNoteSaving,
  eventSongNoteSuccess,
  eventSongNoteError,
  eventSongNoteReset
} = EventSongNoteSlice.actions

export default EventSongNoteSlice.reducer;
